import List from 'modules/Referral/List/List'
import Reducer from 'modules/Referral/List/reducer'

export default List

export { Reducer }
